export default () =>
  document.cookie.split('; ').reduce(
    (o, c) => {
      const [key, value] = c.split('=');
      o[key] = value;
      return o;
    },
    {} as Record<string, string>,
  );
